import '../../style/index.less';
import './index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/checkbox/style/index.js
// module id = 924
// module chunks = 2